var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{class:_vm.classBenefitItem,attrs:{"pointer":""},on:{"click":_vm.goToShowBenefit}},[_c('v-flex',{staticStyle:{"position":"relative"},attrs:{"text-xs-center":""}},[_c('v-img',{style:(_vm.widthImg),attrs:{"src":_vm.benefit.image}},[_c('v-flex',{class:_vm.classTextCard},[_vm._v(" "+_vm._s(_vm.benefit.name)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }